/* ==========================================================================
   contact-form.js — contact form section
   Client-side checks (ported from the mockup's initContact): invalid fields are
   flagged and focused instead of sending. A valid form is posted natively to
   Shopify ({% form 'contact' %}); after sending, the confirmation is focused.
   ========================================================================== */
(() => {
  'use strict';
  const ZC = window.ZC;
  if (!ZC) return;

  ZC.mount((root) => {
    ZC.$$('[data-contact-section]', root).forEach((section) => {
      if (!ZC.once(section, 'contact')) return;
      const form = ZC.$('[data-contact-form]', section);
      if (!form) return;

      const done = ZC.$('[data-form-done]', form);
      if (done) { done.focus({ preventScroll: false }); return; }
      const errors = ZC.$('[data-form-errors]', form);
      if (errors) errors.focus({ preventScroll: false });

      const rules = {
        name: [(v) => v.trim().length > 1, section.dataset.errName],
        email: [(v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()), section.dataset.errEmail],
        message: [(v) => v.trim().length > 4, section.dataset.errMessage],
      };
      const fields = ZC.$$('[data-rule]', form);
      const check = (el, show) => {
        const [test, text] = rules[el.dataset.rule];
        const err = el.parentElement.querySelector('[data-err]');
        const ok = test(el.value);
        el.setAttribute('aria-invalid', String(!ok && show));
        if (err) err.textContent = ok || !show ? '' : text;
        return ok;
      };
      fields.forEach((el) => el.addEventListener('input', () => {
        if (el.getAttribute('aria-invalid') === 'true') check(el, true);
      }));
      form.addEventListener('submit', (e) => {
        let first = null;
        fields.forEach((el) => { if (!check(el, true) && !first) first = el; });
        if (first) { e.preventDefault(); first.focus(); }
      });
    });
  });
})();
